var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('h2',{staticClass:"title is-4"},[_vm._v("Results")]),(_vm.loaded)?_c('scatter-chart',{attrs:{"chartdata":_vm.chartdata,"options":_vm.options,"styles":_vm.styles}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }